export const styles = () => ({
  workStyleDescriptionPaper: {
    width: '100%',
    padding: 16,
  },
});
